import { ModalChangeVehicle } from '@modals/modalChangeVehicle';
import EditIcon from '@mui/icons-material/Edit';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import {
  Link,
  Box,
  IconButton,
  Menu,
  Fade,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Theme,
} from '@mui/material';
import { useState } from 'react';
import { useCarStore } from '@store/carInfoStore';
import { useHistory, useLocation } from 'react-router-dom';
import LogoPrimary from '@assets/images/logo-primary.png';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { ZustandContext } from '@store/modalStore';
import { CustomButton } from '@buttons/CustomButton';
import { ModalHelp } from '@modals/ModalHelp';
import { ModalContact } from '@modals/ModalNeedHelp/ModalContact';
import { useButtonNeedHelpVisibleStore } from '@store/buttonNeedHelpVisisble';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  logo: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  spacer: {
    marginLeft: theme.spacing(2),
  },
  menu: {
    padding: 0,
  },
  popOverPaper: {
    width: '100%',
    marginTop: 40,
  },
}));

export function TabletNavbar() {
  const { pathname } = useLocation();
  const { car } = useCarStore();
  const [anchorElMobile, setAnchorElMobile] = useState<null | HTMLElement>(
    null
  );
  const openMobile = Boolean(anchorElMobile);
  const { breakpoints, palette } = useTheme();
  const { visibleButton } = useButtonNeedHelpVisibleStore();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const classes = useStyles();
  const { push } = useHistory();
  const { show, hide } = React.useContext(ZustandContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => setAnchorEl(null);
  const handleCloseMobile = () => setAnchorElMobile(null);
  const handleClickMobile = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMobile(event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const availablePath = (): boolean => {
    if (pathname === '/') {
      return false;
    } else if (pathname === '/hiring') {
      return true;
    } else if (pathname === '/confirm') {
      return false;
    } else if (pathname === '/payment') {
      return true;
    } else if (pathname === '/welcome') {
      return false;
    } else if (pathname === '/home-alt') {
      return false;
    } else if (pathname === '/quotation') {
      return false;
    }
    return true;
  };

  const isCurrentHome = (): boolean => {
    if (pathname === '/') {
      return true;
    } else if (pathname === '/home-alt') {
      return false;
    } else if (pathname === '/quotation') {
      return false;
    }
    return true;
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className={classes.logo}>
      <Box
        component={'img'}
        src={LogoPrimary}
        sx={{
          maxWidth: { xs: 100, md: 120 },
        }}
        style={{
          objectFit: 'contain',
          cursor: 'pointer',
        }}
        alt={'Inter, seguro, seguro'}
        onClick={() => push('/')}
      />
      {isCurrentHome() ? (
        //boton ayuda !home
        <Box>
          {visibleButton && (
            <CustomButton
              text={'¿Necesitas ayuda?'}
              onClick={() => {
                if (pathname === '/') {
                  show(ModalHelp, { onClose: hide });
                  return;
                }
                show(ModalContact, { onClose: hide });
              }}
              variant="text"
              fontWeight="400"
              style={{
                color: '#039ECC',
                fontSize: '14px',
                textTransform: 'none',
              }}
            />
          )}
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={(e) => handleClickMobile(e)}
            style={{
              color: palette.primary.main,
              marginLeft: 8,
              padding: 0,
            }}
          >
            {!openMobile ? <MenuIcon /> : <ClearIcon />}
          </IconButton>
        </Box>
      ) : availablePath() && pathname !== '/hiring' ? (
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography
              variant={'caption'}
              style={{ fontWeight: 'bold', color: '#424242' }}
            >
              {`${car.assembler}`}
            </Typography>
            <Typography
              variant={'caption'}
              style={{ fontWeight: 'normal', color: '#424242' }}
            >
              {`${car.description}`}
            </Typography>
          </Box>
          <Box>
            <EditIcon
              onClick={() => show(ModalChangeVehicle, { onClose: hide })}
              style={{ color: '#039ECC' }}
            />
          </Box>
        </Box>
      ) : null}
      <Menu
        open={openMobile}
        anchorEl={anchorElMobile}
        onClose={handleCloseMobile}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        MenuListProps={{
          disablePadding: true,
        }}
        PaperProps={{
          square: true,
          elevation: 0,
          style: {
            borderRadius: 0,
          },
        }}
        PopoverClasses={{
          paper: classes.popOverPaper,
        }}
      >
        <Box padding={2}>
          {Array.from({ length: 4 }, (v, k) =>
            Math.floor(Math.random() * 4)
          ).map((_, i) => (
            <div key={i}>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <CustomButton
                  text={
                    i === 0
                      ? 'Seguros'
                      : i === 1
                      ? 'Moto Segura'
                      : i === 2
                      ? 'Quienes Somos'
                      : i === 3
                      ? 'Blog'
                      : i === 4
                      ? 'Promociones'
                      : ''
                  }
                  //@ts-ignore
                  onClick={(e) => {
                    if (i === 0) {
                      handleClick(e);
                    }
                    if (i === 1) {
                      window.open("https://inter-motosegura-qa.web.app/");
                    }
                    if (i === 2) {
                      window.open('https://inter.mx/about-us', '_blank');
                    }
                    if (i === 3) {
                      window.open('https://inter.mx/blog', '_blank');
                    }
                    if (i === 4) {
                      window.open('https://inter.mx/promotions', '_blank');
                    }
                  }}
                  size={'medium'}
                  color={i === 0 ? 'inherit' : 'inherit'}
                  style={{
                    width: '100%',
                    textTransform: 'none',
                    height: i === 0 ? undefined : undefined,
                  }}
                  variant={i === 0 ? 'text' : 'text'}
                />
                <Menu
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                >
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '10px 15px',
                    }}
                  >
                    <Link
                      target="_blank"
                      href="https://medicoseguro.inter.mx/inicio"
                      style={{
                        textDecoration: 'none',
                        padding: '5px',
                        color: 'black',
                      }}
                    >
                      Médico Seguro
                    </Link>
                    <Link
                      target="_blank"
                      href="https://mascotasegura.inter.mx/seguro-mascota/landing"
                      style={{
                        textDecoration: 'none',
                        padding: '5px',
                        color: 'black',
                      }}
                    >
                      Mascota Segura
                    </Link>
                    <Link
                      target="_blank"
                      href="https://productos.inter.mx/bien-seguro"
                      style={{
                        textDecoration: 'none',
                        padding: '5px',
                        color: 'black',
                      }}
                    >
                      Bien Seguro
                    </Link>
                    <Link
                      target="_blank"
                      href="https://inter.mx/viaje-seguro"
                      style={{
                        textDecoration: 'none',
                        padding: '5px',
                        color: 'black',
                      }}
                    >
                      Viaja Seguro
                    </Link>
                  </Box>
                </Menu>
              </div>
              <Divider />
            </div>
          ))}
        </Box>
      </Menu>
    </div>
  );
}
